import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRight,
  faBox,
  faBuilding,
  faCheck,
  faChevronRight,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faClockRotateLeft,
  faCode,
  faCopy,
  faDownload,
  faFolder,
  faGlobe,
  faIdBadge,
  faKey,
  faLink,
  faListCheck,
  faLock,
  faMagnifyingGlass,
  faPalette,
  faPlug,
  faPlus,
  faQrcode,
  faRightLeft,
  faRotate,
  faShieldHalved,
  faTerminal,
  faTowerBroadcast,
  faTriangleExclamation,
  faUsers,
  faVrCardboard,
  faXmark
} from '@fortawesome/pro-solid-svg-icons'
import { faClock, faCopy as faCopyRegular, faFolderOpen, faNewspaper, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

// The LMS pages' icons, drawn the way the rest of the admin draws them: the
// react-fontawesome component over the bundled pro icons (shared/icon/icon.js).
// The pages used to write Font Awesome's stylesheet classes on an <i>, but the
// admin bundle has no Font Awesome stylesheet, so every one rendered nothing.
// Each icon the pages use is imported by name here, so the bundle holds only
// those. `name` is Font Awesome's own name ("circle-info").
const SOLID = {
  'arrow-right': faArrowRight,
  box: faBox,
  building: faBuilding,
  check: faCheck,
  'chevron-right': faChevronRight,
  'circle-check': faCircleCheck,
  'circle-exclamation': faCircleExclamation,
  'circle-info': faCircleInfo,
  'clock-rotate-left': faClockRotateLeft,
  code: faCode,
  copy: faCopy,
  download: faDownload,
  folder: faFolder,
  globe: faGlobe,
  'id-badge': faIdBadge,
  key: faKey,
  link: faLink,
  'list-check': faListCheck,
  lock: faLock,
  'magnifying-glass': faMagnifyingGlass,
  palette: faPalette,
  plug: faPlug,
  plus: faPlus,
  qrcode: faQrcode,
  'right-left': faRightLeft,
  rotate: faRotate,
  'shield-halved': faShieldHalved,
  terminal: faTerminal,
  'tower-broadcast': faTowerBroadcast,
  'triangle-exclamation': faTriangleExclamation,
  users: faUsers,
  'vr-cardboard': faVrCardboard,
  xmark: faXmark
}

const REGULAR = {
  clock: faClock,
  copy: faCopyRegular,
  'folder-open': faFolderOpen,
  newspaper: faNewspaper,
  'trash-can': faTrashCan
}

export const LMS_ICONS = { solid: Object.keys(SOLID), regular: Object.keys(REGULAR) }

// An icon this file does not import draws nothing in the app, and fails a test
// so the page that asked for it is caught before it ships.
export const LmsIcon = ({ name, regular, className, style, spin }) => {
  const icon = (regular ? REGULAR : SOLID)[name]
  if (!icon) {
    if (process.env.NODE_ENV === 'test') throw new Error(`LmsIcon: no ${regular ? 'regular' : 'solid'} icon named "${name}"; import it in lms-icon.js`)
    return null
  }
  return <FontAwesomeIcon icon={icon} className={className} style={style} spin={spin} />
}
